export default __webpack_public_path__ + "static/media/step1.7098d135.png";